import { render, staticRenderFns } from "./SuratPenunjangForm.vue?vue&type=template&id=38509321&"
import script from "./SuratPenunjangForm.vue?vue&type=script&lang=js&"
export * from "./SuratPenunjangForm.vue?vue&type=script&lang=js&"
import style0 from "./SuratPenunjangForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports